<template>
  <div class="">
    <div class="col-12">
      <b-card header="<i class='fa fa-file-o'></i> Detil Pengajuan">
        <div v-if="!DataHeader || !listdokap" style="height: 20rem"
          class="d-flex align-items-center justify-content-center">
          <half-circle-spinner :animation-duration="1000" :size="60" :color="'#000000'" />
        </div>
        <div class="" v-if="DataHeader && listdokap">
          <div class="row">
            <div class="col-12">
              <div v-if="DataHeader.status === '10'" class="p-3 pull-right">
                <button type="button" class="btn btn-success" @click="cekkirim"><i class="fa fa-send"></i>
                  Kirim</button>
              </div>
              <!-- <div  class="p-3 pull-right">
              <button  type="button" class="btn btn-success" @click="cekkirim"><i class="fa fa-send"></i> Kirim</button>
            </div> -->
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <b-card header="<i class='fa fa-file-o'></i> Data Pengajuan Izin">
                <div class="row">
                  <div class="col-6">
                    <table class="table table-bordered table-sm">
                      <tr>
                        <td class="d-none d-sm-block">{{ DataHeader.URAIAN }}</td>
                        <td>{{ DataHeader.npwp }}</td>
                      </tr>
                      <tr>
                        <td class="d-none d-sm-block">Nama</td>
                        <td>{{ DataHeader.NM_PERUSAHAAN }}</td>
                      </tr>
                      <tr>
                        <td class="d-none d-sm-block">Alamat</td>
                        <td>{{ DataHeader.AL_PERUSAHAAN }}</td>
                      </tr>
                      <tr>
                        <td class="d-none d-sm-block">No HP/Telepon</td>
                        <td>{{ DataHeader.no_hp }}</td>
                      </tr>
                      <tr>
                        <td class="d-none d-sm-block">Email</td>
                        <td>{{ DataHeader.email }}</td>
                      </tr>
                    </table>
                  </div>
                  <div class="col-6">
                    <table class="table table-bordered table-sm">
                      <tr>
                        <td class="d-none d-sm-block">Kantor</td>
                        <td>020400 - KPU BC Tipe B Batam</td>
                      </tr>
                      <tr>
                        <td class="d-none d-sm-block">No Permohonan</td>
                        <td>{{ DataHeader.no_mohon }}</td>
                      </tr>
                      <tr>
                        <td class="d-none d-sm-block">Tanggal Permohonan</td>
                        <td>{{ DataHeader.tgl_mohon }}</td>
                      </tr>
                      <tr>
                        <td class="d-none d-sm-block">Jenis Permohonan Izin</td>
                        <td>{{ DataHeader.nama_ijin }}</td>
                      </tr>
                    </table>
                  </div>

                </div>
              </b-card>
            </div>
            <div class="col-12">
              <b-card header="<i class='fa fa-file-o'></i> Dokumen Pelengkap">
                <div class="row">
                  <div class="col-12">
                    Lampiran Dokumen / Data
                    <button title="Tambah Dokumen/Data Pelengkap" type="button" class="btn btn-success pull-right"
                      @click="addModal"><i class="fa fa-plus"></i> Add Dokap</button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <table class="table table-bordered table-sm">
                      <thead>
                        <tr>
                          <th>Nama Dokumen</th>
                          <th class="d-none d-sm-block">Nomor</th>
                          <th>Tanggal</th>
                          <th class="d-none d-md-block">Keterangan</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="dokap in listdokap">
                          <td>{{ dokap.nama_dokap }}</td>
                          <td class="d-none d-sm-block">{{ dokap.isian1 }}</td>
                          <!-- <td>{{ dokap.isian1 + referensiDokapDtl(dokap.tabel_ref, dokap.kolom1, dokap.kolom2, dokap.isian1) }}</td> -->
                          <td>{{ dokap.isian2 }}</td>
                          <td class="d-none d-md-block">{{ dokap.keterangan }}</td>
                          <td>
                            <a title="Download Dokumen Pelengkap" v-if="dokap.url_file !== null" :href="dokap.url_file"
                              target="_blank" class="btn btn-warning"><i class="fa fa-download"></i></a>
                            <!-- <a title="Download Dokumen Pelengkap" v-if="dokap.nm_file !== null" :href="'http://103.233.145.212/backper/public' + dokap.url_file + '/' + dokap.nm_file" target="_blank" class="btn btn-warning"><i class="fa fa-download"></i></a> -->
                            <!-- <a title="Download Dokumen Pelengkap" v-if="dokap.nm_file !== null" :href="'http://localhost/backper/public' + dokap.url_file + '/' + dokap.nm_file" target="_blank" class="btn btn-warning"><i class="fa fa-download"></i></a> -->
                            <button title="Edit Dokumen/Data Pelengkap" type="button"
                              @click="editDokap(dokap.id_permohonan_dokap)" class="btn btn-primary"><i
                                class="fa fa-edit"></i></button>
                            <!-- tombol edit dokap detail -->
                            <button title="Edit Dokumen/Data Pelengkap" v-if="dokap.kd_dokap === 151" type="button"
                              @click="opendtl(dokap.id_permohonan_dokap, dokap.kd_dokap)" class="btn btn-secondary"><i
                                class="fa fa-edit"></i></button>
                            <button title="Edit Dokumen/Data Pelengkap"
                              v-if="dokap.kd_dokap === 145 || dokap.kd_dokap === 146" type="button"
                              @click="opendtl(dokap.id_permohonan_dokap, dokap.kd_dokap)" class="btn btn-secondary"><i
                                class="fa fa-edit"></i></button>
                            <!--  -->
                            <button title="Hapus Dokumen/Data Pelengkap" v-if="dokap.fl_mandatory === null"
                              class="btn btn-danger" @click="confir(dokap.id_permohonan_dokap)"><i
                                class="fa fa-trash-o"></i></button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </b-card>
            </div>
            <div class="col-12">
              <router-link :to="'/pengajuanftz'" class="btn btn-secondary pull-right"><i class="fa fa-mail-reply"></i>
                Back</router-link>
            </div>
          </div>
        </div>
      </b-card>
    </div>
    <b-modal hide-footer title="Tambah Dokumen Pelengkap" v-model="ModalDokap" @ok="ModalDokap = false">
      <div class="row">
        <div class="col-12">
          <vue-progress-bar></vue-progress-bar>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <b-form-fieldset label="Jenis Dokumen Pelengkap">
            <select title="Pilih Jenis Dokumen/Data Pelengkap" class="form-control" v-model="isidokap.jndok">
              <option value="">Pilih Jenis Dokumen/Data</option>
              <option v-for="jn in jndokap" @click="getDtlDokap(jn.kd_dokap)" :value="jn.kd_dokap">{{ jn.nama_dokap }}
              </option>
            </select>
          </b-form-fieldset>
          <b-form-fieldset :label="field.isi1">
            <!-- <input v-if="field.tipe1 === 'date'" name="This" v-validate="'required|email'" type="date" v-model="isidokap.isian1" class="form-control">
            <input v-if="field.tipe1 === 'text'" name="This" v-validate="'required|email'" type="text" v-model="isidokap.isian1" class="form-control"> -->
            <select title="Pilih Negara" class="form-control" v-model="isidokap.negara"
              v-if="field.tabel_ref === 'referensi.tr_pelln' || field.tabel_ref === 'referensi.tr_pelabuhan'">
              <option value="">Pilih Negara</option>
              <option v-for="jn in jnNegara" @click="referensiDokap()" :value="jn.id_lokasi">{{ jn.nm_lokasi }}</option>
            </select>
            <select title="Pilih Data Pelengkap" lass="form-control" v-model="isidokap.isian1"
              v-if="field.tabel_ref !== null">
              <option value="">Pilih Jenis Data</option>
              <option v-for="jn in jnPelln" :value="jn.id_lokasi">{{ jn.nm_lokasi }}</option>
            </select>
            <input title="Nomor/Kode Dokumen/Data" name="This" v-validate="'required'"
              v-if="field.tipe1 === 'date' && field.tabel_ref === null" type="date" v-model="isidokap.isian1"
              class="form-control">
            <input title="Nomor/Kode Dokumen/Data" name="This" v-validate="'required'"
              v-if="field.tipe1 === 'text' && field.tabel_ref === null" type="text" v-model="isidokap.isian1"
              class="form-control">
            <vue-numeric title="Nomor/Kode Dokumen/Data" name="This" v-validate="'required'"
              v-if="field.tipe1 === 'number' && field.tabel_ref === null" separator="." v-bind:precision="2"
              v-model="isidokap.isian1"></vue-numeric>
            <small class="text-danger" v-show="errors.has('This')">
              {{ errors.first('This') }}
            </small>
          </b-form-fieldset>
          <b-form-fieldset v-if="field.tipe2 === 'text'" :label="field.isi1">
            <input title="Tanggal Dokumen/Data" name="Isi" v-validate="'required|field'" type="text"
              v-model="isidokap.isian2" class="form-control">
            <small class="text-danger" v-show="errors.has('Isi')">
              {{ errors.first('Isi') }}
            </small>
          </b-form-fieldset>
          <b-form-fieldset v-if="field.tipe2 === 'Date'" label="Tanggal">
            <input name="Tanggal" v-validate="'required|field'" type="date" v-model="isidokap.isian2"
              class="form-control">
            <small class="text-danger" v-show="errors.has('Tanggal')">
              {{ errors.first('Tanggal') }}
            </small>
          </b-form-fieldset>
          <b-form-fieldset v-if="field.expire === 'Y'" label="Akhir Berlaku">
            <b-form-input title="Akhir Berlaku Dokumen/Data" name="Akhir Berlaku" v-validate="'required|field'"
              type="date" v-model="edit.akhirberlaku"></b-form-input>
            <small class="text-danger" v-show="errors.has('Akhir Berlaku')">
              {{ errors.first('Akhir Berlaku') }}
            </small>
          </b-form-fieldset>
          <b-form-fieldset label="Keterangan">
            <input title="Keterangan Terkait Dokumen/Data" class="form-control" type="text"
              v-model="isidokap.keterangan"></input>
          </b-form-fieldset>
          <b-form-fieldset v-if="field.fl_file === 'Y'" label="Upload File (Max. 800 Kb)">
            <input type="file" class="form-control" @change="fileChanged">
            <div class="row">
              <div class="col-12">
                <vue-progress-bar></vue-progress-bar>
              </div>
            </div>
          </b-form-fieldset>
          <button type="button" class="btn btn-success pull-right" @click="saveDokap()" name="button">Save</button>
        </div>
      </div>
    </b-modal>
    <b-modal hide-footer title="Edit Dokumen Pelengkap" v-model="Modaledit" @ok="Modaledit = false">
      <div class="row">
        <div class="col-12">
          <vue-progress-bar></vue-progress-bar>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <b-form-fieldset label="Edit Dokumen Pelengkap">
            <select title="Jenis Dokumen/Data" class="form-control" v-model="edit.jndok" disabled>
              <option value="">Pilih Jenis Dokumen</option>
              <option v-for="jn in jndokap" @click="getDtlDokap(jn.kd_dokap)" :value="jn.kd_dokap">{{ jn.nama_dokap }}
              </option>
            </select>
          </b-form-fieldset>
          <b-form-fieldset :label="field.isi1">
            <!-- <vue-instant class="form-control" v-on:input="referensiDokap()" v-model="edit.negara" :suggestion-attribute="suggestionAttribute" :suggestions="jnPelln"></vue-instant> -->
            <!-- <input name="This" v-validate="'required'" v-on:input="referensiDokap()" v-model="edit.negara" class="form-control"> -->
            <select title="Pilih Kode Negara" class="form-control" v-model="edit.negara"
              v-if="field.tabel_ref === 'referensi.tr_pelln' || field.tabel_ref === 'referensi.tr_pelabuhan'">
              <option value="">Pilih Negara</option>
              <option v-for="jn in jnNegara" @click="referensiDokap()" :value="jn.id_lokasi">{{ jn.nm_lokasi }}</option>
            </select>
            <select title="Nomor/Kode Dokumen/Data" class="form-control" v-model="edit.isian1"
              v-if="field.tabel_ref !== null">
              <option value="">Pilih Jenis Dokumen</option>
              <option @click="edit.keterangan = jn.nm_lokasi" v-for="jn in jnPelln" :value="jn.id_lokasi">{{
                  jn.nm_lokasi
              }}</option>
            </select>
            <input title="Tanggal Dokumen/Data" name="This" v-validate="'required'"
              v-if="field.tipe1 === 'date' && field.tabel_ref === null" type="date" v-model="edit.isian1"
              class="form-control">
            <input :maxlength="field.maxchar1" title="Nomor/Kode Dokumen/Data" name="This" v-validate="'required'"
              v-if="field.tipe1 === 'text' && field.tabel_ref === null" type="text" v-model="edit.isian1"
              class="form-control">
            <!-- <input title="Nomor/Kode Dokumen/Data" name="This" v-validate="'required'" v-if="field.tipe1 === 'number'&&field.tabel_ref === null" type="number" v-model="edit.isian1" class="form-control"> -->
            <vue-numeric title="Nomor/Kode Dokumen/Data" name="This" v-validate="'required'"
              v-if="field.tipe1 === 'number' && field.tabel_ref === null" separator="." v-bind:precision="2"
              v-model="edit.isian1"></vue-numeric>
            <small class="text-danger" v-show="errors.has('This')">
              {{ errors.first('This') }}
            </small>
          </b-form-fieldset>
          <b-form-fieldset v-if="field.tipe2 === 'text'" :label="field.isi2">
            <input :maxlength="field.maxchar2" title="Nomor/Kode Dokumen/Data" name="Isi" v-validate="'required'"
              type="text" v-model="edit.isian2" class="form-control">
            <small class="text-danger" v-show="errors.has('Isi')">
              {{ errors.first('Isi') }}
            </small>
          </b-form-fieldset>
          <b-form-fieldset v-if="field.tipe2 === 'Date'" label="Tanggal">
            <input title="Tanggal Dokumen/Data" name="Tanggal" v-validate="'required'" type="date" v-model="edit.isian2"
              class="form-control">
            <small class="text-danger" v-show="errors.has('Tanggal')">
              {{ errors.first('Tanggal') }}
            </small>
          </b-form-fieldset>
          <b-form-fieldset v-if="field.expire === 'Y'" label="Akhir Berlaku">
            <b-form-input title="Akhir Berlaku Dokumen/Data" name="Akhir Berlaku" v-validate="'required'" type="date"
              v-model="edit.akhirberlaku"></b-form-input>
          </b-form-fieldset>
          <b-form-fieldset label="Keterangan">
            <input title="Keterangan Dokumen/Data" class="form-control" type="text" v-model="edit.keterangan"></input>
          </b-form-fieldset>
          <b-form-fieldset v-if="field.fl_file === 'Y'" title="Upload Dokumen" label="Upload File (Max. 700 Kb)">
            <input title="Upload Dokumen" type="file" class="form-control" @change="fileChanged">
          </b-form-fieldset>
          <button type="button" class="btn btn-success pull-right" @click="updateDokap()" name="button">Save</button>
        </div>
      </div>
    </b-modal>

    <!-- PETI KEMAS  -->
    <b-modal hide-footer title="Edit Dokumen Pelengkap" v-model="Modaleditdtl" @ok="Modaleditdtl = false" size="medium">
      <div class="form-group row">
        <div class="col-6">
          <b-form-fieldset label="Nomor Peti Kemas">
            <input maxlength="11" title="Nomor Peti Kemas" name="petikemas" v-validate="'required'" v-model="nocont"
              class="form-control">
            <small class="text-danger" v-show="errors.has('petikemas')">
              Nomor Peti Kemas wajib diisi
            </small>
          </b-form-fieldset>
        </div>
        <div class="col-3">
          <b-form-fieldset label="Ukuran">
            <input maxlength="2" title="Nomor Peti Kemas" name="ukuran" v-validate="{ required: true, numeric: true }"
              v-model="ukcont" class="form-control">
            <small class="text-danger" v-show="errors.has('ukuran')">
              Wajib diisi dan berisi angka
            </small>
          </b-form-fieldset>
        </div>
        <div class="col-2">
          <b-form-fieldset label="<br>">
            <button title="Tambah" type="button" @click="addRow()" class="btn btn-primary"><i class="fa fa-plus"></i>
              Tambah</button>
          </b-form-fieldset>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-12">
          <!-- BUAT BIKIN SCROLL -->
          <div style="height:300px;max-height:300px;overflow-y:scroll;">
            <table class="table table-responsive-sm table-bordered">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Nomor Peti Kemas</th>
                  <th>Ukuran</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(peti, index) in cont">
                  <td>{{ index + 1 }}</td>
                  <td>{{ peti.isian1 }}</td>
                  <td>{{ peti.isian2 }}</td>
                  <td>
                    <button title="Hapus" type="button" @click="hapusrow(index)" class="btn btn-danger"><i
                        class="fa fa-trash"></i></button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="">
        <button type="button" class="btn btn-danger pull-right" @click="Modaleditdtl = false"
          name="button">Batal</button> &nbsp;
        <button type="button" class="btn btn-success pull-right" @click="savedokapdtl" name="button">Simpan</button>
      </div>
    </b-modal>

    <!-- Detail Dokumen Upload -->
    <b-modal hide-footer title="Edit Dokumen Pelengkap" v-model="Modaleditdtl1" @ok="Modaleditdtl1 = false" size="lg">
      <div class="form-group row">
        <div class="col-3">
          <b-form-fieldset label="Nomor">
            <input title="Nomor" name="" v-validate="'required'" v-model="nocont" class="form-control">
            <!-- <small class="text-danger" v-show="errors.has('petikemas')">
              Nomor Peti Kemas wajib diisi
            </small> -->
          </b-form-fieldset>
        </div>
        <div class="col-2">
          <b-form-fieldset label="Tanggal">
            <input type="date" title="Nomor Peti Kemas" name="" v-validate="'required'" v-model="ukcont"
              class="form-control">
            <!-- <small class="text-danger" v-show="errors.has('ukuran')">
              Wajib diisi dan berisi angka
            </small> -->
          </b-form-fieldset>
        </div>
        <div class="col-6">
          <b-form-fieldset label="Upload File (Max. 800 Kb)">
            <input type="file" class="form-control" @change="fileChanged">
            <div class="row">
              <div class="col-12">
                <vue-progress-bar></vue-progress-bar>
              </div>
            </div>
          </b-form-fieldset>
        </div>
        <div class="col-2">
          <b-form-fieldset label="">
            <button title="Tambah Dokumen" type="button" @click="savedokapdtl1" class="btn btn-primary"><i
                class="fa fa-plus"></i> Tambah Dokumen</button>
          </b-form-fieldset>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-12">
          <!-- BUAT BIKIN SCROLL -->
          <div style="height:300px;max-height:300px;overflow-y:scroll;">
            <table class="table table-responsive-sm table-bordered">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Nomor</th>
                  <th>Tanggal</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(peti, index) in cont">
                  <td>{{ index + 1 }}</td>
                  <td>{{ peti.isian1 }}</td>
                  <td>{{ peti.isian2 }}</td>
                  <td>
                    <a title="Download Dokumen Pelengkap" v-if="peti.nm_file !== null"
                      :href="$http.options.base + peti.url_file + '/' + peti.nm_file" target="_blank"
                      class="btn btn-warning"><i class="fa fa-download"></i></a>
                    <!-- <a title="Download Dokumen Pelengkap" v-if="peti.nm_file !== null" :href="'http://localhost/backper/public' + peti.url_file + '/' + peti.nm_file" target="_blank" class="btn btn-warning"><i class="fa fa-download"></i></a> -->
                    <button title="Hapus" type="button" @click="confirmdtl(peti.id_permohonan_dokap_dtl)"
                      class="btn btn-danger"><i class="fa fa-trash"></i></button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </b-modal>


    <b-modal hide-footer title="Persetujuan" v-model="ModalDisclaimer" @ok="ModalDisclaimer = false">
      <div class="row">
        <div class="col-12">
          <b-form-fieldset>
            <b-form-checkbox v-model="disclaimer" value="Y" unchecked-value="">
              Saya menyatakan bahwa data yang disampaikan adalah benar
              dan saya bertanggungjawab atas kebenaran data/dokumen yang disampaikan
            </b-form-checkbox>
            <div v-if="disclaimer === 'Y'" class="p-3 pull-right">
              <button type="button" class="btn btn-success" @click="kirim"><i class="fa fa-send"></i> Kirim</button>
            </div>
          </b-form-fieldset>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import swal from 'sweetalert'
import VueNumeric from 'vue-numeric'
import { HalfCircleSpinner } from 'epic-spinners'

export default {
  data () {
    return {
      Modaledit: false,
      Modaleditdtl: false,
      Modaleditdtl1: false,
      ModalDokap: false,
      ModalDisclaimer: false,
      disclaimer: '',
      nmTabel: '',
      nmKolom: '',
      nmPar: '',
      uraian: '',
      nocont: '',
      ukcont: '',
      jmlcont: 0,
      jmlck: 0,
      jmlba: 0,
      cont: [],
      isian: '',
      fileSize: 0,
      fileExt: '',
      fileName: '',
      fileValid: '',
      DataHeader: null,
      dokap_current: '',
      kd_dokap_current: '',
      listdokap: null,
      dokapdtl: [],
      jndokap: [],
      jnPelln: [],
      jnNegara: [],
      user: [],
      suggestionAttribute: 'original_title',
      isidokap: {
        jndok: '',
        isian1: '',
        isian2: '',
        akhirberlaku: '',
        keterangan: '',
        file: '',
        negara: '-'
      },
      idijin: '',
      field: {
        isi1: '',
        tipe1: '',
        isi2: '',
        tipe2: '',
        expire: '',
        kolom1: '',
        kolom2: '',
        tabel_ref: '',
        fl_file: ''
      },
      edit: {
        idperdokap: '',
        idpermohonan: '',
        isian1: '',
        isian2: '',
        akhirberlaku: '',
        keterangan: '',
        file: '',
        pelln: '',
        negara: '-',
        fileSize: '',
        fl_file: ''
      },
      pdf: {
        show: true,
        pdfList: [
          '',
          'http://localhost/backper/public/file/dokap/20171212/9oAFswM38T3ZnNW9.pdf'
        ],
        src: '',
        loadedRatio: 0,
        page: 1,
        numPages: 0,
        rotate: 0
      }
    }
  },
  created () {
    this.getHeader()
    this.getDokap()
    this.getJnDokap()
    this.getNegara()
    this.edit.negara = '-'
  },
  methods: {
    addRow () {
      if (this.cont.length >= this.jmlcont) {
        swal('error', 'isian tidak boleh lebih dari ' + this.jmlcont, 'error')
      } else {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.cont.push({
              isian1: this.nocont,
              isian2: this.ukcont
            })
            this.cont = this.cont
          }
        })
      }
    },
    hapusrow (index) {
      this.cont.splice(index, 1)
      this.cont = this.cont
    },
    cekkirim () {
      this.ModalDisclaimer = true
    },
    kirim () {
      if (this.disclaimer === 'Y') {
        swal({
          title: 'Kirim data',
          text: 'Anda yakin akan mengirim data ini?',
          icon: 'warning',
          buttons: {
            cancel: 'Cancel',
            Yes: 'Yes'
          }
        })
          .then((value) => {
            switch (value) {
              case 'Yes':
                var data = {
                  user: this.$store.getters['auth/user']['username'],
                  idmohon: this.$route.params.idmohon
                }
                this.$http.post('kirim', data)
                  .then(response => {
                    if (response.data.hasil) {
                      var mail = {
                        page: 'kirim',
                        idmohon: this.$route.params.idmohon
                      }
                      this.$http.post('bc/mail/sendmail', mail)
                      var mail1 = {
                        page: 'petugas',
                        idmohon: this.$route.params.idmohon
                      }
                      this.$http.post('bc/mail/sendmail', mail1)
                    }
                    swal(response.data.status, response.data.message, response.data.status)
                    this.$router.push('/pengajuanftz')
                  })
            }
          })
      } else {
        swal('Kirim Data', 'Pengiriman data tidak berhasil, disclaimer belum diisi...!!!', 'error')
      }
    },
    savedokapdtl () {
      if (this.jmlcont <= this.cont.length) {
        var data = {
          idrekam: this.$store.getters['auth/user']['username'],
          id_permohonan_dokap: this.dokap_current,
          cont: this.cont
        }
        this.$http.post('savedokapdtl', data)
          .then(response => {
            swal(response.data.status, response.data.message, response.data.status)
            this.Modaleditdtl = false
          })
      } else {
        swal('error', 'isian tidak sama dengan jumlah', 'error')
      }
    },
    savedokapdtl1 () {
      if (this.cekFile()) {
        var data = {
          id_dokap: this.dokap_current,
          kd_dokap: this.kd_dokap_current,
          isian1: this.nocont,
          isian2: this.ukcont,
          file: this.isidokap.file,
          idrekam: this.user.user,
          ext: this.fileExt
        }
        this.$http.post('savedokapdtl1', data)
          .then(response => {
            swal(response.data.status, response.data.message, response.data.status)
            this.ResetField()
            this.Reset()
            this.getDokapdtl()
          })
      } else {
        swal('Gagal simpan data', this.fileValid, 'error')
      }
    },
    fileChanged (e) {
      this.$Progress.start()
      var fileReader = new FileReader()
      fileReader.readAsDataURL(e.target.files[0])
      this.fileSize = e.target.files[0].size / 1024
      this.fileExt = e.target.files[0].name.substr((e.target.files[0].name.lastIndexOf('.') + 1))
      this.fileName = e.target.files[0].name
      fileReader.onload = (e) => {
        this.isidokap.file = e.target.result
        this.edit.file = e.target.result
        this.$Progress.finish()
      }
    },
    fileChangeddtl (e) {
      this.$Progress.start()
      var fileReader = new FileReader()
      fileReader.readAsDataURL(e.target.files[0])
      this.fileSize = e.target.files[0].size / 1024
      this.fileExt = e.target.files[0].name.substr((e.target.files[0].name.lastIndexOf('.') + 1))
      this.fileName = e.target.files[0].name
      fileReader.onload = (e) => {
        this.isidokap.file = e.target.result
        this.edit.file = e.target.result
        this.$Progress.finish()
      }
    },
    cekFile () {
      var hasil = true
      if (this.fileSize > 0) {
        this.fileValid = 'File ' + this.fileName
        if (this.fileSize > 800) {
          this.fileValid = this.fileValid + ' berukuran ' + Math.round(this.fileSize * 100) / 100 + ' Kb, max. 800 Kb. ' + '\n\r'
          hasil = false
        }
        // if (this.fileExt !== 'application/pdf') {
        //   this.fileValid = this.fileValid + 'File bukan pdf, ' + this.fileExt
        //   hasil = false
        // }
      }
      return hasil
    },
    getDtlDokap (iddokap) {
      this.$http.get('ref/jndokap/' + iddokap)
        .then(response => {
          this.field.isi1 = response.data.isian1
          this.field.tipe1 = response.data.tipe1
          this.field.maxchar1 = response.data.maxchar1
          this.field.isi2 = response.data.isian2
          this.field.maxchar2 = response.data.maxchar2
          this.field.tipe2 = response.data.tipe2
          this.field.expire = response.data.expire
          this.field.tabel_ref = response.data.tabel_ref
          this.field.kolom1 = response.data.kolom1
          this.field.kolom2 = response.data.kolom2
          this.field.fl_file = response.data.fl_file
          if (this.field.tabel_ref === 'referensi.tr_pelln' || this.field.tabel_ref === 'referensi.tr_pelabuhan') {
            // this.referensiDokap()
          } else {
            this.referensiDokap()
          }
        })
    },
    getJnDokap () {
      this.$http.get('ref/jndokap')
        .then(response => {
          this.jndokap = response.data
        })
    },
    getHeader () {
      var data = {
        user: this.$store.getters['auth/user']['username'],
        idmohon: this.$route.params.idmohon
      }
      this.user = data
      this.$http.post('dtlheader', data)
        .then(response => {
          this.DataHeader = response.data
          this.idijin = response.data.id_ijin
        })
    },
    getDokap () {
      var idijinn = {
        user: this.$store.getters['auth/user']['username'],
        idijin: this.$route.params.idmohon
      }
      this.$http.post('dokap', idijinn)
        .then(response => {
          this.listdokap = response.data
          for (var i = 0; i < response.data.length; i++) {
            if (response.data[i].kd_dokap === 151) {
              this.jmlcont = response.data[i].isian1
            } else if (response.data[i].kd_dokap === 145) {
              this.jmlck = response.data[i].isian1
            } else if (response.data[i].kd_dokap === 146) {
              this.jmlba = response.data[i].isian1
            }
          }
        })
    },
    getDokapdtl () {
      var iddokap = {
        iddokap: this.dokap_current
      }
      this.$http.post('dokapdtl', iddokap)
        .then(response => {
          this.cont = response.data
        })
    },
    referensiDokap () {
      var neg = ''
      if (this.ModalDokap === true) {
        neg = this.isidokap.negara
      } else {
        neg = this.edit.negara
      }
      this.$http.get('ref/referensiDokap/' + this.field.tabel_ref + '/' + this.field.kolom1 + '/' + this.field.kolom2 + '/' + neg)
        .then(response => {
          this.jnPelln = response.data
        })
    },
    referensiDokapDtl (tabel, kolom1, kolom2, par) {
      if (tabel !== null) {
        this.$http.get('ref/referensiDokapDtl/' + tabel + '/' + kolom1 + '/' + kolom2 + '/' + par)
          .then(response => {
            this.uraian = response.data.nm_lokasi
          })
      } else {
        this.uraian = ''
      }
      return this.uraian
    },
    getNegara () {
      this.$http.get('ref/referensiDokap/referensi.tr_negara/id_negara/nm_negara/-')
        .then(response => {
          this.jnNegara = response.data
        })
    },
    addModal () {
      this.ModalDokap = true
      this.Reset()
    },
    opendtl (id, kd) {
      if (kd === 151) {
        this.Modaleditdtl = true
        this.dokap_current = id
        this.getDokapdtl()
      } else if (kd === 145 || kd === 146) {
        this.Modaleditdtl1 = true
        this.dokap_current = id
        this.kd_dokap_current = kd
        this.getDokapdtl()
        this.getDtlDokap(kd)
      }
    },
    editDokap (id) {
      this.ResetField()
      this.Modaledit = true
      var iddokap = {
        id: id
      }
      this.$http.post('geteditDokap', iddokap)
        .then(response => {
          this.edit.idperdokap = response.data.id_permohonan_dokap
          this.edit.idpermohonan = response.data.id_permohonan
          this.edit.jndok = response.data.kd_dokap
          this.edit.isian1 = response.data.isian1
          this.edit.isian2 = response.data.isian2
          this.edit.akhirberlaku = response.data.akhir_berlaku
          this.edit.keterangan = response.data.keterangan
          this.edit.fl_file = response.data.fl_file
          this.getDtlDokap(response.data.kd_dokap)
        })
      this.Reset()
    },
    Reset () {
      // Reset our form values
      this.isidokap.jndok = null
      this.isidokap.isian1 = null
      this.isidokap.isian2 = null
      this.isidokap.akhirberlaku = null
      this.isidokap.keterangan = null
      this.isidokap.file = null
      this.field.isi1 = null
      this.field.tipe1 = null
      this.field.isi2 = null
      this.field.tipe2 = null
      this.field.expire = null
      this.field.tabel_ref = null
      this.field.kolom1 = null
      this.field.kolom2 = null
      this.field.fl_file = null
      this.jnPelln = []
      this.nocont = null
      this.ukcont = null
      // this.fileSize = 0
      // this.fileExt = ''
      // this.fileName = ''
      // this.fileValid = ''
    },
    ResetField () {
      // Reset our form values
      this.field.isi1 = null
      this.field.tipe1 = null
      this.field.isi2 = null
      this.field.tipe2 = null
      this.field.expire = null
      this.field.tabel_ref = null
      this.field.kolom1 = null
      this.field.kolom2 = null
      this.field.fl_file = null
      this.isidokap.negara = '-'
      this.isidokap.file = null
      this.edit.negara = '-'
      this.jnPelln = []
      this.cont = null
      this.ukuran = null
      // this.fileSize = 0
      // this.fileExt = ''
      // this.fileName = ''
      // this.fileValid = ''
    },
    updateDokap () {
      if (this.cekFile()) {
        if (this.edit.isian1 === null) {
          this.edit.isian1 = this.edit.negara
        }
        var data = {
          id_permohonan_dokap: this.edit.idperdokap,
          id_permohonan: this.edit.idpermohonan,
          kd_dokap: this.edit.jndok,
          isian1: this.edit.isian1,
          isian2: this.edit.isian2,
          akhirberlaku: this.edit.akhirberlaku,
          keterangan: this.edit.keterangan,
          file: this.edit.fl_file === 'Y' ? this.edit.file : null,
          idrekam: this.user.user,
          ext: this.fileExt
        }
        this.$http.post('updateDokap', data)
          .then(response => {
            swal(response.data.status, response.data.message, response.data.status)
            this.getDokap()
            this.getHeader()
            this.saveDokapMasterEdit()
            this.ResetField()
            this.Modaledit = false
          })
      } else {
        swal('Gagal simpan data', this.fileValid, 'error')
      }
    },
    saveDokap () {
      if (this.cekFile()) {
        if (this.isidokap.isian1 === null) {
          this.isidokap.isian1 = this.isidokap.negara
        }
        var data = {
          id_permohonan: this.DataHeader.id_permohonan,
          kd_dokap: this.isidokap.jndok,
          isian1: this.isidokap.isian1,
          isian2: this.isidokap.isian2,
          akhirberlaku: this.isidokap.akhirberlaku,
          keterangan: this.isidokap.keterangan,
          file: this.field.fl_file === 'Y' ? this.isidokap.file : null,
          idrekam: this.user.user,
          ext: this.fileExt
        }
        this.$http.post('savedokap', data)
          .then(response => {
            swal(response.data.status, response.data.message, response.data.status)
            this.getDokap()
            this.saveDokapMasterAdd()
            this.ResetField()
            this.ModalDokap = false
            this.onReset()
          })
      } else {
        swal('Gagal simpan data', this.fileValid, 'error')
      }
    },
    saveDokapMasterAdd () {
      if (this.isidokap.isian1 === null) {
        this.isidokap.isian1 = this.isidokap.negara
      }
      var data = {
        kd_dokap: this.isidokap.jndok,
        nomor: this.isidokap.isian1,
        tanggal: this.isidokap.isian2,
        akhirberlaku: this.isidokap.akhirberlaku,
        keterangan: this.isidokap.keterangan,
        file: this.isidokap.file,
        idrekam: this.user.user,
        ext: this.fileExt
      }
      this.$http.post('saveDokapMaster', data)
        .then(response => {
          swal(response.data.status, response.data.message, response.data.status)
        })
    },
    saveDokapMasterEdit () {
      if (this.edit.isian1 === null) {
        this.edit.isian1 = this.edit.negara
      }
      var data = {
        kd_dokap: this.edit.jndok,
        nomor: this.edit.isian1,
        tanggal: this.edit.isian2,
        akhirberlaku: this.edit.akhirberlaku,
        keterangan: this.edit.keterangan,
        file: this.edit.file,
        idrekam: this.user.user,
        ext: this.fileExt
      }
      this.$http.post('saveDokapMaster', data)
        .then(response => {
          swal(response.data.status, response.data.message, response.data.status)
        })
    },
    // ambilData (pnmTabel, pkolom1, pkolom2, pparam) {
    //   var data = {
    //     tabel_ref: pnmTabel,
    //     kolom1: pkolom1,
    //     kolom2: pkolom2,
    //     param: pparam
    //   }
    //   this.$http.post('ambilData', data)
    //     .then(response => {
    //       this.isian = response.data.hasil
    //     })
    // },
    confir (iddel) {
      swal({
        title: 'Hapus dokumen pelengkap',
        text: 'Anda yakin akan menghapus data ini?',
        icon: 'warning',
        buttons: {
          cancel: 'Cancel',
          Yes: 'Yes'
        }
      })
        .then((value) => {
          switch (value) {
            case 'Yes':
              this.deleteDokap(iddel)
          }
        })
    },
    confirmdtl (iddel) {
      swal({
        title: 'Hapus dokumen pelengkap',
        text: 'Anda yakin akan menghapus data ini?',
        icon: 'warning',
        buttons: {
          cancel: 'Cancel',
          Yes: 'Yes'
        }
      })
        .then((value) => {
          switch (value) {
            case 'Yes':
              this.deleteDokapdtl(iddel)
          }
        })
    },
    deleteDokap (id) {
      var data = {
        user: this.$store.getters['auth/user']['username'],
        delid: id
      }
      this.$http.post('deleteDokap', data)
        .then(response => {
          swal(response.data.status, response.data.message, response.data.status)
          this.getDokapdtl()
          this.getHeader()
          this.ResetField()
        })
    },
    deleteDokapdtl (id) {
      var data = {
        user: this.$store.getters['auth/user']['username'],
        delid: id
      }
      this.$http.post('deleteDokapdtl', data)
        .then(response => {
          swal(response.data.status, response.data.message, response.data.status)
          this.getDokapdtl()
          this.getHeader()
          this.ResetField()
          this.Reset()
        })
    }
  },
  components: {
    VueNumeric,
    HalfCircleSpinner
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/Pengajuan/DetilHeaderFtz.vue?57cf1df8